export default __webpack_public_path__ + "static/media/tvb-idol.4d991275.webp";